import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { GoogleChartsModule } from '../../../node_modules/angular-google-charts';
import { NgbModule, NgbActiveModal } from '../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { VisitorareachartComponent } from '@app/dashboard/visitorareachart/visitorareachart.component';
import { VisitordoughnutchartComponent } from '@app/dashboard/visitordoughnutchart/visitordoughnutchart.component';
import { SummaryComponent } from '@app/dashboard/summary/summary.component';
import { BlockedcolumnchartComponent } from '@app/dashboard/blockedcolumnchart/blockedcolumnchart.component';
import { BlockeddoughnutchartComponent } from '@app/dashboard/blockeddoughnutchart/blockeddoughnutchart.component';

@NgModule({
  imports: [
    CommonModule,
    GoogleChartsModule,
    NgbModule.forRoot()
  ],
  exports: [DashboardComponent, VisitorareachartComponent, VisitordoughnutchartComponent, SummaryComponent, BlockedcolumnchartComponent,BlockeddoughnutchartComponent],
  declarations: [DashboardComponent, VisitorareachartComponent, VisitordoughnutchartComponent, SummaryComponent, BlockedcolumnchartComponent,BlockeddoughnutchartComponent],
  providers: [NgbActiveModal],

})
export class DashboardModule { }
